import * as React from "react";
function SvgCircleList(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <g
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      >
        <circle cx={16} cy={16} r={15} />
        <path d="M8 11h2M14 11h10M8 16h2M14 16h10M8 21h2M14 21h10" />
      </g>
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgCircleList);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
